import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type HomeActiveIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function HomeActiveIcon({
  className,
  pathClassName = "stroke-white",
  ...props
}: HomeActiveIconProps) {
  return (
    <Svg
      width={28}
      height={29}
      viewBox="0 0 28 29"
      fill="none"
      className={className}
      {...props}
    >
      <Path
        d="M25.018 11.552L23.07 23.22a3.5 3.5 0 01-1.167 2.088 3.745 3.745 0 01-2.333.817H8.358a3.5 3.5 0 01-3.418-2.905L2.99 11.552A3.5 3.5 0 013.26 9.57a3.5 3.5 0 011.306-1.505l7.56-4.667a3.5 3.5 0 013.675 0l7.549 4.667c.59.35 1.062.87 1.353 1.493a3.5 3.5 0 01.315 1.995z"
        className={pathClassName}
      />
    </Svg>
  );
}

export default HomeActiveIcon;
